export default {
  name: "LinkTile",
  props: {
    tile: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isHinted: {
      type: Boolean,
      default: false
    },
    iconSet: {
      type: Array,
      required: true
    }
  },
  computed: {},
  methods: {
    handleClick() {
      this.$emit("onClick", this.tile);
    }
  }
};